import React, { useEffect } from 'react';
import { useLocation, useMatch, Outlet } from 'react-router-dom';

import { ReactComponent as Logo } from 'assets/images/logo.svg';
import { AuthContextProvider } from './contexts/AuthContext';
import ALL_ROUTES from 'config/routes';
import { GroupsIcon, SaveIcon, CategoryIcon, CloseIcon } from 'utils/icons';
import { initializeGoogleAds } from 'utils/googleAds';

import './styles.scss';
const AuthLayout = () => {
  const { pathname } = useLocation();
  const isSignUp = useMatch(ALL_ROUTES.AUTH_CHILDREN.SIGNUP);
  const isLogin = useMatch(ALL_ROUTES.AUTH_CHILDREN.LOGIN);
  const isCardAuth = Boolean(isLogin || isSignUp);

  useEffect(() => {
    // Include client-side redirects from the public app entry URL.
    if (isCardAuth) initializeGoogleAds();
  }, [isCardAuth]);

  useEffect(() => {
    if (window.scrollY > 0) window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <AuthContextProvider>
      <div
        className={`auth-layout container-fluid p-0 ${
          isCardAuth ? 'auth-layout--signin' : ''
        }`}
      >
        <div className="auth-layout__background" />
        <div className="d-flex auth-layout__container row mx-5">
          <div className="auth-layout__container__left-section col-xs-12 col-md-6 pt-5 ps-0">
            {!isCardAuth && (
              <div className="app-logo">
                <Logo />
              </div>
            )}
            <div
              className={`app-welcome-content ${
                isSignUp
                  ? 'app-welcome-content--signup'
                  : 'app-welcome-content--signin'
              }`}
            >
              {!isSignUp && (
                <div className="app-welcome-text">
                  <div className="app-welcome-text__title">Welcome back to</div>
                  <div className="app-welcome-text__name">CineBudget Pro</div>
                </div>
              )}
              <div className="app-intro">
                <div className="app-intro__text">
                  Easily build budgets for your creative projects
                </div>
                <div
                  className={`app-intro__video  ${
                    isSignUp
                      ? 'app-intro__video--signup'
                      : 'app-intro__video--signin'
                  }`}
                >
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/Infd6rjTL6o?si=MkqYxastZeWZSKXB"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
              {!isSignUp && (
                <div className="app-welcome">
                  <div className="app-welcome__description">
                    What&apos;s New
                    <ul>
                      <li>
                        <GroupsIcon />
                        Real Time Collaboration
                      </li>
                      <li>
                        <SaveIcon />
                        Auto Save
                      </li>
                      <li>
                        <CategoryIcon />
                        Customizable Category Depth
                      </li>
                      <li>
                        <CloseIcon />
                        Unit Multipliers
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="auth-layout__container__right-section col-xs-12 col-md-6">
            <div
              className={`form-container col-md-9 ${
                isCardAuth ? 'form-container--signin' : ''
              }`}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </AuthContextProvider>
  );
};

export default AuthLayout;
